import React, { useState } from "react";
import { broadCloseIcon, broadOpenIcon } from "../../../../assets/images";
import { Link } from "react-router-dom";
import { tableHeader } from "./BalanceSheetTable";
import { getData } from "../common";
import { currencySignAndNegativeValueAdjust, getStartDateFromEndDate } from "../../../../utils/commonFunctions";

type AppProps = {
  singleData: any;
  type?: string;
  count: number;
  index?: number;
  recuIndex?: number;
  subHeader: string;
  endDate: string;
  currencySign: string | undefined;
  finalRedirectLink: { pathname: string } | any;
  isLedgerStatementPresent?: boolean;
  isStocksStatementPresent?: boolean;
  selectedBranchId?: any;
  branchName?: any;
};

const StatementTableData = ({
  singleData,
  type,
  count,
  currencySign,
  finalRedirectLink,
  recuIndex,
  subHeader,
  endDate,
  index,
  isLedgerStatementPresent,
  isStocksStatementPresent,
  selectedBranchId,
  branchName,
}: AppProps) => {
  const startDate = getStartDateFromEndDate(endDate);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSetLocalStorageData = (ledgerId: number) => {
    localStorage.setItem("ledger_id", ledgerId.toString());
    localStorage.setItem("start_date", startDate);
    localStorage.setItem("end_date", endDate);
    localStorage.setItem("branch_id", selectedBranchId);
    localStorage.setItem("branchName", branchName);
  };

  const handleSetStockSummaryLocalStorageData = (stockUnitName: string) => {
    localStorage.setItem("stock_item_name", stockUnitName);
    localStorage.setItem("start_date", startDate);
    localStorage.setItem("end_date", endDate);
  };

  if (singleData?.data?.length > 0) {
    return (
      <>
        <tr>
          {tableHeader?.map((thead: any) => {
            if (thead?.value === "ledger_name") {
              return (
                <td
                  style={{ paddingLeft: type == "recurring" ? `${3.9 * count}rem` : "" }}
                  onClick={() => setIsOpen(!isOpen)}
                >
                  <p style={{ marginLeft: "-32px", fontWeight: "700" }}>
                    <span style={{ display: "inline-block", marginRight: "2px" }}>
                      {isOpen ? (
                        <img
                          width="30px"
                          style={{ cursor: "pointer" }}
                          src={broadOpenIcon}
                          className="accordion-arrow"
                          alt="open"
                        />
                      ) : (
                        <img
                          width="30px"
                          style={{ cursor: "pointer" }}
                          src={broadCloseIcon}
                          className="accordion-arrow"
                          alt="colse"
                        />
                      )}
                    </span>
                    {count == 1 && `${index}.`} {singleData?.ledger_name || singleData?.stock_group_name}
                  </p>
                </td>
              );
            }
            if (thead?.value === "closing_amount") {
              return (
                <td style={{ verticalAlign: "middle" }}>
                  {!isOpen ? (
                    <p className="bold-count" style={{ fontWeight: "700" }}>
                      {" "}
                      {currencySignAndNegativeValueAdjust(
                        currencySign,
                        singleData?.closing_amount ? singleData?.closing_amount?.toFixed(2)?.toString() : "0"
                      )}
                    </p>
                  ) : (
                    ""
                  )}
                </td>
              );
            }
          })}
        </tr>

        {isOpen && (
          <>
            {getData(singleData?.data)?.map((item: any, recuIndex: number) => (
              <StatementTableData
                singleData={item}
                type="recurring"
                count={count + 1}
                endDate={endDate}
                currencySign={currencySign}
                index={index}
                subHeader={subHeader}
                recuIndex={recuIndex}
                finalRedirectLink={finalRedirectLink}
                isLedgerStatementPresent={isLedgerStatementPresent}
                selectedBranchId={selectedBranchId}
                branchName={branchName}
              />
            ))}
          </>
        )}
      </>
    );
  } else {
    return (
      <tr>
        {tableHeader?.map((thead: any) => {
          if (thead?.value === "ledger_name") {
            return (
              <td style={{ paddingLeft: type == "recurring" ? `${3.9 * count}rem` : "" }}>
                {singleData?.ledger_name === "Retained Earnings" ? (
                  singleData?.ledger_name || subHeader === "INVENTORY"
                ) : (subHeader === "INVENTORY" ? isStocksStatementPresent : isLedgerStatementPresent) ? (
                  <Link
                    target="_blank"
                    to={subHeader === "INVENTORY" ? finalRedirectLink(singleData?.stock_item_id) : finalRedirectLink}
                    onClick={() =>
                      subHeader === "INVENTORY"
                        ? handleSetStockSummaryLocalStorageData(singleData?.stock_item_name)
                        : handleSetLocalStorageData(singleData?.ledger_id)
                    }
                    style={{ textDecoration: "underLine", cursor: "pointer", color: "#dd4433" }}
                  >
                    {/* in case of inventory, we don't want to show the count on child level */}
                    {!singleData?.parent_id && subHeader !== "INVENTORY" ? `${index}.` : ""}{" "}
                    {subHeader === "INVENTORY" ? singleData?.stock_item_name : singleData?.ledger_name}
                  </Link>
                ) : (
                  <span style={{ color: "#dd4433" }}>
                    {" "}
                    {/* in case of inventory, we don't want to show the count on child level */}
                    {!singleData?.parent_id && subHeader !== "INVENTORY" ? `${index}.` : ""}{" "}
                    {subHeader === "INVENTORY" ? singleData?.stock_item_name : singleData?.ledger_name}
                  </span>
                )}
              </td>
            );
          }
          if (thead?.value === "closing_amount") {
            return (
              <td className="light-count">
                {currencySignAndNegativeValueAdjust(
                  currencySign,
                  singleData?.closing_amount ? singleData?.closing_amount?.toFixed(2)?.toString() : "0"
                )}
              </td>
            );
          }
        })}
      </tr>
    );
  }
};

export default StatementTableData;
